export const blockIconsCommonactionsAccountBoxNew = (
	<span className='material-symbols-outlined'>account_box</span>
);
